/**
 * Star
 * @param {*} level 综合难度
 */

export default (level) => {
    return "⭐️".repeat(level ? level : 1);
}

